export default "__VITE_ASSET__BSQNNhHA__"